import { createFileRoute, notFound } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { ProductMissing, ShopProductPage } from "@/features/site/modules/shop-product/shop-product";
import { productPageHead, type TrainerLoaderData } from "@/features/site/utils/trainer-head";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/$trainerSlug/shop/$productId/")({
  component: ProductPage,
  notFoundComponent: ProductMissing,
  // The product is read before the page draws, so its name, price and words are in the server's
  // HTML. One that is not on the shelf is a real 404; a request that fails is left to the browser.
  loader: async ({ params, parentMatchPromise }) => {
    // Named by hand: with its `head` reading the loader's data too, the router infers the layout's as `never`.
    const loaded = (await parentMatchPromise).loaderData as TrainerLoaderData | undefined;
    const organizationId = loaded?.page.organizationId;
    const { data, status } = organizationId
      ? await sdk.publicShop.$productId.$get.setParams({ productId: params.productId }).setQueryParams({ organizationId }).send()
      : { data: null, status: null };
    if (status && status >= 400 && status < 500) throw notFound();
    return {
      crumb: m.shop_title(),
      product: data ?? null,
      slug: loaded?.page.slug ?? params.trainerSlug,
      businessName: loaded?.business.name ?? "",
    };
  },
  head: ({ loaderData }) =>
    loaderData?.product
      ? productPageHead({ product: loaderData.product, slug: loaderData.slug, businessName: loaderData.businessName })
      : {},
});

function ProductPage() {
  const { productId } = Route.useParams();
  const { product } = Route.useLoaderData();
  return <ShopProductPage key={productId} productId={productId} initial={product} />;
}
